import { render, staticRenderFns } from "./NewsBW2026NagoyaENG.vue?vue&type=template&id=17c741d6&scoped=true&"
import script from "./NewsBW2026NagoyaENG.vue?vue&type=script&lang=js&"
export * from "./NewsBW2026NagoyaENG.vue?vue&type=script&lang=js&"
import style0 from "./NewsBW2026NagoyaENG.vue?vue&type=style&index=0&id=17c741d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c741d6",
  null
  
)

export default component.exports